var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 8.33326L10.6666 4.99993M1.08325 17.9166L3.90356 17.6032C4.24813 17.5649 4.42042 17.5458 4.58146 17.4937C4.72433 17.4474 4.86029 17.3821 4.98566 17.2994C5.12696 17.2062 5.24954 17.0836 5.49469 16.8385L16.4999 5.83326C17.4204 4.91279 17.4204 3.4204 16.4999 2.49993C15.5795 1.57945 14.0871 1.57945 13.1666 2.49992L2.16136 13.5052C1.91621 13.7503 1.79363 13.8729 1.70045 14.0142C1.61778 14.1396 1.55243 14.2755 1.50618 14.4184C1.45405 14.5794 1.43491 14.7517 1.39662 15.0963L1.08325 17.9166Z",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a9151681ee7dbda29e27db41b97c32b7.svg";
export { ForwardRef as ReactComponent };